import React from 'react';
import { connect } from 'react-redux';
import CyberComponent from 'containers/CyberComponent';
import FormElement from 'components/FormElement';
import {
  formatAddressList,
  showAddressDetails,
  onSelectPoc
} from 'helpers/BillingHelper';
import { handleInputChange, cleanBillingAddressInfo } from 'actions/request';

class BillingAddressSelector extends CyberComponent {
  render() {
    const {
      show,
      request,
      user,
      toggleSelector,
      handleInputChange
    } = this.props;

    if (!show) return null;

    const isEditable = user.canEditRequest && !request.isPaid;

    if (request.billingAddresses) {
      return (
        <div>
          <FormElement
            type="select"
            id="billingAddressId"
            label="Billing Address"
            value={request.billingAddressId}
            onChange={onSelectPoc.bind(
              this,
              toggleSelector,
              handleInputChange,
              cleanBillingAddressInfo
            )}
            options={formatAddressList(request.billingAddresses)}
            editable={isEditable}
          />
          {showAddressDetails(request)}
        </div>
      );
    }
    return null;
  }
}

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange,
    cleanBillingAddressInfo
  }
)(BillingAddressSelector);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/BillingAddressSelector.js